import React, { useState, useEffect } from 'react'
import { Table, Form, Alert, Button,Modal } from 'react-bootstrap'
import { InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import { toast } from 'react-toastify';
import Backdrop from '../backdrop/backdrop'

function TotalAmountModalPopup({totalAmtToBePaid,driver_id,order_id,...props}) {
  const [loading,setLoading] = useState(false);
  const [totalAmt,setTotalAmt] = useState(totalAmtToBePaid);

  const updateTotalAmountValue = () => {
    props.callback(totalAmt,driver_id,order_id);
    props.onHide();
  }

    return (<>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                    Total Amount
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Table>
                    <tbody>
                        <tr>
                            <td>Total Amount</td>
                            <td><Form.Control type="text" defaultValue={totalAmt} onChange={(e)=>{ setTotalAmt(e.target.value); }}/></td>
                        </tr>
                    </tbody>
                </Table>

                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={()=>{updateTotalAmountValue(); }}>OK</Button>
                    <Button onClick={props.onHide}>Close</Button>
                </Modal.Footer>
            </Modal>
            {loading ? (<Backdrop parentLoadStatus={loading} />) : (null)}
        </>
    )
}

export default TotalAmountModalPopup
